import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import error from "../../assets/images/error.png";

const Error = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      navigate("/");
    }, 2000);
  });
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="error-page text-center mt-5">
            <img src={error} alt="error-page" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error;
